var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Vpay24 = function Vpay24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.314 3H3.7v18h16.614V3z",
    fill: "#253A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.904 3.416H4.116v11.275h15.788V3.416z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 5.459-3.095 7.398H10.88L9.357 6.954a.832.832 0 0 0-.455-.668 8.077 8.077 0 0 0-1.883-.608l.043-.22h3.253a.893.893 0 0 1 .882.756l.805 4.277 1.993-5.032H16z",
    fill: "#253A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.513 17.577c.097.022.197.032.296.028.45 0 .723-.23.723-.63s-.252-.586-.668-.586a1.647 1.647 0 0 0-.35.027v1.161zm-.591-1.599a5.17 5.17 0 0 1 .915-.07c.347-.027.693.072.974.278a.985.985 0 0 1 .323.762c.012.288-.09.57-.284.783a1.425 1.425 0 0 1-1.04.361 2.353 2.353 0 0 1-.297 0v1.293h-.591v-3.407zm4.474 1.944-.257-.848c-.066-.209-.12-.444-.17-.641-.05.197-.099.438-.159.64l-.252.85h.838zm-.942.471-.285.975h-.619l1.057-3.433h.767l1.068 3.433h-.646l-.296-.975h-1.046zm3.258.975v-1.43l-1.046-2.003h.685l.4.881c.11.252.191.45.28.685a8.47 8.47 0 0 1 .29-.685l.426-.881h.658l-1.096 1.987v1.446h-.597z",
    fill: "#fff"
  }));
};

Vpay24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Vpay32 = function Vpay32(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: ".5",
    y: ".5",
    width: "31",
    height: "23",
    rx: "3.5",
    fill: "#fff",
    stroke: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.053 3.053h15.894v17.219H8.053V3.053zm.398 11.182H23.55V3.451H8.451v10.784z",
    fill: "#1C3378"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.658 16.998c.07.02.165.026.281.026.43 0 .693-.221.693-.606 0-.365-.243-.56-.642-.56-.157 0-.27.014-.332.03v1.11zm-.57-1.53a4.7 4.7 0 0 1 .88-.069c.421 0 .729.093.93.269.187.16.309.418.309.727 0 .31-.094.569-.272.746-.23.238-.589.35-.996.35a1.64 1.64 0 0 1-.28-.02v1.24h-.57v-3.243zm4.283 1.858-.247-.81a7.294 7.294 0 0 1-.127-.483l-.033-.132h-.01l-.045.196a9.22 9.22 0 0 1-.103.42l-.243.809h.808zm-.902.453-.271.932h-.594l1.01-3.287h.734l1.024 3.287h-.617l-.285-.932h-1zm3.114-.44v1.372h.575v-1.385l1.047-1.902h-.65l-.379.843a13.23 13.23 0 0 0-.276.654h-.008c-.086-.226-.165-.41-.272-.654l-.38-.843h-.653l.996 1.915z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.819 5.408-2.962 7.072H14.92l-1.458-5.645c-.088-.347-.165-.474-.433-.622-.442-.237-1.168-.461-1.806-.601l.042-.204h3.113c.396 0 .754.264.844.72l.771 4.091 1.903-4.81h1.922z",
    fill: "#1C3378"
  }));
};

Vpay32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Vpay24,
  '32': Vpay32
};
export var Vpay = function Vpay(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Vpay' icon. Please use one of the available sizes: '24', '32'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};